import { render } from "./manage-name.vue?vue&type=template&id=77d477d3&scoped=true&ts=true"
import script from "./manage-name.vue?vue&type=script&lang=ts"
export * from "./manage-name.vue?vue&type=script&lang=ts"

import "./manage-name.vue?vue&type=style&index=0&id=77d477d3&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/3Mswgxxg/0/im/im-web/iguopin-chat/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77d477d3"]])

export default __exports__